import React from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Home.css";
import JournalList from "./JournalList";
export default function Home() {
  const navigate = useNavigate();

  return (
    <div className="home-bg">
      <nav className="home-nav">
        <div className="nav-logo">
          <img src="/logo192.png" alt="logo" style={{ width: 32, marginRight: 10 }} />
          <span>Travel Journal</span>
        </div>
        <div className="nav-links">
          <Link to="/">Home</Link>
          {/* <Link to="/explore">Explore</Link> */}
          <Link to="/profile">My Profile</Link>
          <Link to="/login" className="nav-btn blue">Login</Link>
          <Link to="/register" className="nav-btn gray">Register</Link>
        </div>
      </nav>

      <main className="home-main">
        <h1 className="home-title">Discover Hidden Gems, Together</h1>
        <p className="home-subtitle">
          Share your journeys, explore unique spots found by our community and let our AI build your next perfect itinerary.
        </p>

        {/* CTA Row - with new AI buttons */}
        <div className="home-cta-row">
          <button
            className="home-cta-btn blue"
            onClick={() => navigate("/create-journal")}
          >
            <span style={{ marginRight: 9 }}>☆</span> Share a Trip
          </button>
          {/* <Link to="/explore">
            <button className="home-cta-btn gray">Explore Journals</button>
          </Link> */}
        </div>

        {/* AI Feature Buttons */}
        <div className="ai-feature-btn-row">
          <button
            className="ai-feature-btn itinerary"
            onClick={() => navigate("/ai-itinerary")}
          >
            ✈️ AI Itinerary
          </button>
          <button
            className="ai-feature-btn recommendation"
            onClick={() => navigate("/ai-recommendation")}
          >
            🧭 AI Recommendation
          </button>
        </div>

        <div className="explore-section">
          <h2 className="explore-title">Explore Journals</h2>
          {/* <div className="explore-search-row">
            <input className="explore-search" placeholder="Search by destination..." />
            <button className="explore-search-btn">🔍</button>
          </div> */}
          <div className="explore-journals-row">
            
            {/* End added cards */}
          </div>
        </div>
        <div className="explore-journals-row">
            <JournalList />  {/* Replace static journal cards with dynamic list */}
          </div>
      </main>
    </div>
  );
}
